import { isRichTextEmpty } from './richText';
import { JOB_LISTING_JOB_TYPE_OPTIONS } from '../constants/jobListingFormOptions';
import { sanitizeSalaryInput } from './validateJobListingForm';

export const toDateInput = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toISOString().slice(0, 10);
};

export const parseIndustryIds = (raw) => {
  if (Array.isArray(raw)) {
    return raw.map((item) => Number(item)).filter((id) => Number.isFinite(id) && id > 0);
  }
  if (typeof raw === 'string' && raw.trim()) {
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        return parsed.map((item) => Number(item)).filter((id) => Number.isFinite(id) && id > 0);
      }
    } catch {
      return [];
    }
  }
  return [];
};

export const EMPTY_JOB_LISTING_FORM = {
  title: '',
  company: '',
  location: '',
  description: '',
  salary: '',
  jobType: '',
  jobMode: '',
  experience: '',
  source: 'Company',
  skills: [],
  lastApplicationDate: '',
  industryIds: [],
  customIndustries: [],
};

export const toArraySkills = (raw) => {
  if (Array.isArray(raw)) {
    return raw.map((item) => String(item).trim()).filter(Boolean);
  }
  return String(raw || '')
    .split(/[,;|]/g)
    .map((item) => item.trim())
    .filter(Boolean);
};

export const normalizeJobType = (value) => {
  if (!value) return '';
  const lowered = String(value).trim().toLowerCase();
  if (lowered === 'full time') return 'Full-time';
  if (lowered === 'part time') return 'Part-time';
  return JOB_LISTING_JOB_TYPE_OPTIONS.find((type) => type.toLowerCase() === lowered) || '';
};

export const withCurrentOption = (options, current) => {
  const value = String(current || '').trim();
  if (!value || options.includes(value)) return options;
  return [value, ...options];
};

export const jobToFormData = (job = {}) => ({
  title: job.title || '',
  company: job.company || '',
  location: job.location || '',
  description: job.description || '',
  salary: job.salary || job.salaryRange || job.salary_range || '',
  jobType: normalizeJobType(job.jobType || job.job_type),
  jobMode: job.jobMode || job.job_mode || '',
  experience: job.experience || job.experienceRequired || job.experience_required || '',
  source: job.source || '',
  skills: Array.isArray(job.skills) ? job.skills : toArraySkills(job.skills),
  lastApplicationDate: toDateInput(
    job.lastApplicationDate || job.last_application_date
  ),
  industryIds: (() => {
    const fromIds = parseIndustryIds(job.industryIds ?? job.industry_ids);
    if (fromIds.length > 0) return fromIds;
    if (Array.isArray(job.industries)) {
      return job.industries.map((item) => Number(item?.id)).filter((id) => Number.isFinite(id) && id > 0);
    }
    return [];
  })(),
  customIndustries: Array.isArray(job.customIndustries)
    ? job.customIndustries
    : Array.isArray(job.custom_industries)
      ? job.custom_industries
      : [],
});

export const toJobListingApiPayload = (formData) => ({
  title: formData.title?.trim(),
  company: formData.company?.trim(),
  location: formData.location?.trim() || undefined,
  description: isRichTextEmpty(formData.description) ? undefined : formData.description.trim(),
  salaryRange: (() => {
    const salary = sanitizeSalaryInput(formData.salary)?.trim();
    return salary || undefined;
  })(),
  jobType: formData.jobType?.trim() || undefined,
  jobMode: formData.jobMode?.trim() || undefined,
  experienceRequired: formData.experience?.trim() || undefined,
  source: formData.source?.trim() || undefined,
  skills: toArraySkills(formData.skills).filter((skill) => String(skill).trim().length > 0),
  lastApplicationDate: formData.lastApplicationDate?.trim() || undefined,
  industryIds: Array.isArray(formData.industryIds) ? formData.industryIds : [],
  customIndustries: [],
});
